import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = ["disabled"]

import { computed, PropType, ref } from "vue";
import TextField from "../atoms/TextField.vue";
import {
  InvestimentEnum,
  EditInvest,
  Investment,
  InvestimentStatusEnum,
} from "@/services/invest/types";

import { isNullOrEmpty } from "@/services/utils";
import Selector from "../atoms/Selector.vue";
import SwitchButton from "../atoms/SwitchButton.vue";
import InputImage from "@/components/atoms/InputImage.vue";

declare type enumType = keyof typeof InvestimentEnum;


export default /*#__PURE__*/_defineComponent({
  __name: 'FormEditInvestment',
  props: {
  invest: {
    type: Object as PropType<Investment>,
    required: true,
  },
},
  emits: ["add", "editImage"],
  setup(__props, { emit }) {

const props = __props;





const investmentSt = ref([
  InvestimentStatusEnum[0],
  InvestimentStatusEnum[1],
  InvestimentStatusEnum[2],
]);

const id = ref<EditInvest["id"] | undefined>(props.invest.id);
const title = ref<EditInvest["title"] | undefined>(props.invest.title);
const description = ref<EditInvest["description"] | undefined>(
  props.invest.description
);

const value = ref<EditInvest["value"] | undefined>(props.invest.value);
const disableButton = ref<boolean>(false);
const investmentStatus = ref<string>(props.invest.investmentStatus);

const selectedProf = computed(() => {
  if (
    props.invest.monthlyProfitabilityClp &&
    !props.invest.monthlyProfitabilityUf
  ) {
    return 1;
  } else {
    return 0;
  }
});

const IndexTypeSelected = ref<number>(selectedProf.value);

const selectedProfValue = computed(() => {
  switch (IndexTypeSelected.value) {
    case 0:
      return props.invest.monthlyProfitabilityUf;

    case 1:
      return props.invest.monthlyProfitabilityClp;

    default:
      return 0;
  }
});

const profiability = ref(selectedProfValue.value);
const dividendValuesOption = ref<string[]>(["UF", "Pesos Chilenos"]);
const monthlyProfitabilityUf = ref<
  EditInvest["monthlyProfitabilityUf"] | undefined | null
>(props.invest.monthlyProfitabilityUf);
const monthlyProfitabilityClp = ref<
  EditInvest["monthlyProfitabilityClp"] | undefined | null
>(props.invest.monthlyProfitabilityClp);

function getingOptionTypeSelected(newIndexTypeSelected: number) {
  IndexTypeSelected.value = newIndexTypeSelected;
}

function handleSubmit() {
  if (id.value && title.value && description.value && value.value) {
    if (IndexTypeSelected.value) {
      monthlyProfitabilityClp.value = profiability.value;
      monthlyProfitabilityUf.value = null;
    } else {
      monthlyProfitabilityUf.value = profiability.value;
      monthlyProfitabilityClp.value = null;
    }

    const data = new EditInvest(
      id.value !== undefined ? id.value : 0,
      title.value,
      description.value,
      investmentStatus.value,
      value.value,
      monthlyProfitabilityUf.value,
      monthlyProfitabilityClp.value,
      false
    );
    disableButton.value = true;
    emit("add", data);
  }
}
const formHasError = computed(() => {
  const requiredFields = [title.value, description.value, value.value];

  if (requiredFields.some((value) => isNullOrEmpty(value))) {
    return true;
  }

  // Listao de posibles errores del formulario de registro
  const formErrors = [
    titleFieldHasError.value,
    descriptionFieldHasError.value,
    investmentStatus.value,
    valueFieldHasError.value,
  ];
  if (formErrors.some((hasError) => hasError == true)) {
    return true;
  }

  return false;
});
const titleFieldHasError = computed(() => {
  return isNullOrEmpty(title.value);
});

const descriptionFieldHasError = computed(() => {
  return isNullOrEmpty(description.value);
});
const valueFieldHasError = computed(() => {
  return isNullOrEmpty(value.value);
});
const investmentStatusFielHasError = computed(() => {
  return isNullOrEmpty(investmentStatus.value);
});
const profiabilityClpFieldHasError = computed(() => {
  return isNullOrEmpty(monthlyProfitabilityClp.value);
});
const profiabilityUfFieldHasError = computed(() => {
  return isNullOrEmpty(monthlyProfitabilityUf.value);
});
const profiabilityFieldHasError = computed(() => {
  return isNullOrEmpty(profiability.value);
});

const isLoading = ref<boolean>(false);
async function uploadFile(file: File) {
  emit("editImage", file);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoading.value)
      ? (_openBlock(), _createBlock(InputImage, {
          key: 0,
          onUploadFile: uploadFile,
          class: "mt-4"
        }))
      : _createCommentVNode("", true),
    _createVNode(TextField, {
      type: "text",
      name: "Título",
      label: 'Título',
      "hide-details": "",
      model: title.value,
      "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
      hasError: titleFieldHasError.value
    }, null, 8, ["model", "hasError"]),
    _createVNode(TextField, {
      type: "textarea",
      name: "description",
      label: 'Descripción',
      "hide-details": "",
      model: description.value,
      "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
      hasError: descriptionFieldHasError.value
    }, null, 8, ["model", "hasError"]),
    _createVNode(Selector, {
      label: "Estado",
      class: "w-full",
      items: ['Disponible', 'Arrendado', 'Vendido'],
      model: investmentStatus.value,
      "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((investmentStatus).value = $event)),
      hasError: investmentStatusFielHasError.value,
      values: investmentSt.value
    }, null, 8, ["model", "hasError", "values"]),
    _createVNode(TextField, {
      type: "number",
      name: "value",
      label: "Valor de compra en UF",
      "hide-details": "",
      model: value.value,
      "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((value).value = $event)),
      hasError: valueFieldHasError.value
    }, null, 8, ["model", "hasError"]),
    _createElementVNode("div", null, [
      _createElementVNode("p", null, [
        _createVNode(SwitchButton, {
          switchOptions: dividendValuesOption.value,
          defaultIndexSelection: IndexTypeSelected.value,
          label: 'Tipo de renta',
          onSwitchTypeSelection: getingOptionTypeSelected
        }, null, 8, ["switchOptions", "defaultIndexSelection"]),
        _createVNode(TextField, {
          type: "number",
          name: "profiability",
          label: 
            IndexTypeSelected.value
              ? 'Renta mensual en pesos chilenos'
              : 'Renta mensual en UF'
          ,
          "hide-details": "",
          model: profiability.value,
          "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((profiability).value = $event)),
          hasError: profiabilityFieldHasError.value
        }, null, 8, ["label", "model", "hasError"])
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "success btn ml-auto my-2",
        onClick: handleSubmit,
        disabled: formHasError.value || disableButton.value
      }, " Editar ", 8, _hoisted_3)
    ])
  ]))
}
}

})